import Logger from 'nightingale';
import { runSync } from './exec';

const logger = new Logger('app:sound');

const hdmi = (): void => {
  logger.info('sound to hdmi');
  runSync('./sound.sh', ['hdmi']);
};

const jack = (): void => {
  logger.info('sound to jack');
  runSync('./sound.sh', ['jack']);
};

export const update = (config: Object) => {
  if (config.sound === 'hdmi') hdmi();
  if (config.sound === 'jack') jack();
};
